import { Route } from '@angular/router';
import { OverallOverviewPage } from 'app/modules/well-integrity-management/pages/overall-overview/overall-overview.page';

export const wimDashboardRoutes: Route[] = [
    {
        path: 'well-integrity-management',
        children: [
            {
                path: 'overall-overview',
                component: OverallOverviewPage,
            },
        ],
    },
];

export const wimDataManagementRoutes: Route[] = [
    {
        path: 'well-integrity-management',
        children: [],
    },
];

export const wimConfigurationRoutes: Route[] = [
    {
        path: 'kpi-configuration',
        loadComponent: () =>
            import('app/modules/well-integrity-management/pages/kpi-configuration/kpi-configuration.component').then(
                (m) => m.KpiConfigurationComponent,
            ),
    },
];
